/* eslint-disable @typescript-eslint/no-explicit-any */
import { hall } from '@/hall'
import { ModuleBase } from './ModuleBase'
import { base } from '@/base/base'
import { serverErrorMsg } from '@/defines/ServerError'
import { MsgIDs } from '@/defines/MsgIDs'
import { PopupViews } from '@/defines/EnumDefine'
import { wsClient } from '@/net/WebSocketClient'

export class WaterWheelModule extends ModuleBase {
  public info: any = null
  public spinReward = '' //抽奖中奖金额

  init(): void {}

  onClear(): void {}

  onLoad(): void {}

  onDestroy(): void {}

  inits2c(): void {
    ;(hall.s2c as any)['onClientLuckySpinGetAck'] = function (msg: any) {
      //  玩家ID(UserID)
      // 本周内总投注额(从周一0点开始统计)(Total_bets)
      // 当前时间(NowTime)
      // 重置时间(ResetTime)
      // 剩余抽奖次数(LeftSpinTimes)

      // 奖区信息数组(LuckySpinLevelInfos)
      // 转盘类型(1.青铜, 2.白银, 3.黄金, 4.铂金, 5.钻石, 6.超级)(SpinLevel)
      // 抽奖的投注额度限制条件(SpinBetsLimit)
      // 是否已抽奖(AlreadySpin)
      // 抽奖赠金(SpinPrize)
      // 抽奖格列表(SpinCells)

      hall.waterWheelModule.setInfo(msg)
      if (msg == null || msg.UserID != hall.userModule.userId) {
        hall.waterWheelModule.setInfo(null)
      }
      hall.eventDispatcher.emit(hall.EventDefine.OnWaterWheelChange)
      hall.eventDispatcher.emit(hall.EventDefine.ChangeBindActivityRed) //刷新流水转盘红点
    }

    ;(hall.s2c as any)['onClientLuckySpinPlayAck'] = function (msg: any) {
      //        uint32 Ret = 1;					// 响应码
      // uint32 UserID = 2;			// 玩家ID
      // uint32 SpinLevel = 3;		// 转盘类型转盘类型(1.青铜,2.白银,3.黄金,4.铂金,5.钻石,6.超级)
      // string SpinPrize = 4; 	// 抽奖赠金
      // string UserGold = 5;    // 玩家金币
      // string UserBonus = 6;   // 赠金
      // string Total_bets = 7;	// 本周内总投注额(从周一0点开始统计)
      // uint64 NowTime = 8; 		// 当前时间
      // uint64 ResetTime = 9; 	// 重置时间
      // uint32 LeftSpinTimes = 10;	// 剩余抽奖次数
      // repeated LuckySpinLevelInfo LuckySpinLevelInfos = 11; // 奖区信息数组

      if (msg.Ret == 0) {
        hall.waterWheelModule.spinReward = msg.SpinPrize
        hall.eventDispatcher.emit(hall.EventDefine.OnWaterWheelSpinChange)
        hall.eventDispatcher.emit(hall.EventDefine.ChangeBindActivityRed) //刷新流水转盘红点
      } else {
        base.toast(serverErrorMsg(msg.Ret))
      }
    }
  }

  onPreloadData(): void {
    this.sendWaterWheelConfig()
  }

  //获取流水大转盘信息
  sendWaterWheelConfig(): void {
    const msg = {
      UserID: hall.userModule.userId,
      //CID: base.channelId,
    }

    wsClient.send(MsgIDs.ClientLuckySpinGetReq, msg)
  }

  //流水大转盘抽奖
  sendWaterWheelPlay(type: number): void {
    //转盘类型(1.青铜,2.白银,3.黄金,4.铂金,5.钻石,6.超级)
    const msg = {
      UserID: hall.userModule.userId,
      SpinLevel: type,
      ChannelID: base.channelId,
    }

    wsClient.send(MsgIDs.ClientLuckySpinPlayReq, msg)
  }

  setInfo(msg: any) {
    this.info = msg
  }

  //是否侧边栏展示这个活动
  isShowWaterWheelBind() {
    if (this.info) {
      return this.info.LeftSpinTimes > 0
    }

    return false
  }

  // 是否需要弹窗
  popupView() {
    if (this.info) {
      if (this.info.LeftSpinTimes > 0) {
        hall.popupViewModule.addPopupView(PopupViews.WaterWheelPanel)
      }
    }
  }
}
